import { AgentNetServices } from '@fluentsms/agentnet-web-icons';
import { Container, createStyles, makeStyles, Theme } from '@material-ui/core';
import { ReactElement } from 'react';
import { Content } from './Content';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      backgroundColor: theme.palette.brand.legacy,
    },
    logoContainer: {
      cursor: 'pointer',
      marginTop: theme.spacing(4),
      display: 'flex',
      justifyContent: 'space-between',
    },
  }),
);
function HelpHeader(): ReactElement | null {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Container maxWidth="lg">
        <div data-testid="knowledge-base-logoBar" className={classes.logoContainer}>
          <AgentNetServices width={175} />
        </div>
        <Content />
      </Container>
    </div>
  );
}

export { HelpHeader };
